import React, {useEffect} from "react";
import {Navigate} from "react-router";
import {useWauth} from "../auth/WauthProvider";

const CallbackPage = () => {

  const {handleAuthentication, isAuthenticated} = useWauth()
  const message = "Verificando cuenta"

  const referer = '/selector'

  useEffect(() => {
    handleAuthentication()
    // Solo al montar: handleAuthentication se recrea en cada render del provider.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  if (isAuthenticated) {
    return <Navigate to={referer} replace/>
  }

  return (
    <div>
      {message}
    </div>
  )
};

export default CallbackPage;
